module.exports = __webpack_public_path__ + "img/JoeWahba_O_1.ec74eb99.jpg";